import { render, staticRenderFns } from "./SupplierSolicitudeCreationDetail.vue?vue&type=template&id=e401830c&scoped=true&lang=pug"
import script from "./SupplierSolicitudeCreationDetail.vue?vue&type=script&lang=js"
export * from "./SupplierSolicitudeCreationDetail.vue?vue&type=script&lang=js"
import style0 from "./SupplierSolicitudeCreationDetail.vue?vue&type=style&index=0&id=e401830c&prod&lang=scss&scoped=true"
import style1 from "./SupplierSolicitudeCreationDetail.vue?vue&type=style&index=1&id=e401830c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e401830c",
  null
  
)

export default component.exports